"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NicheFormEngine = _interopRequireDefault(require("../../common/NicheFormEngine"));
var _nicheUserFeService = require("niche-user-fe-service");
var _uiSchema = require("./uiSchema");
var _constants = require("../../common/constants");
var _utils = require("../../utils");
var _schema = require("./schema");
var _NicheGoogleLogin = _interopRequireDefault(require("../NicheGoogleLogin"));
var _apis = require("../../common/apis");
var _antd = require("antd");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NicheJwtLogin = props => {
  const [schema, setSchema] = (0, _react.useState)({});
  const [error, setError] = (0, _react.useState)("");
  const {
    token: {
      colorError
    }
  } = _antd.theme.useToken();
  (0, _react.useEffect)(() => {
    (async () => {
      const fetchedSchema = await (0, _schema.getSchema)(props.schemaUrl || _apis.jwtLoginSchemaUrl);
      setSchema(fetchedSchema);
    })();
  }, [props.schemaUrl]);
  const handleLogin = (0, _react.useCallback)(async (url, payload) => {
    await (0, _nicheUserFeService.jwtLogin)(url, payload).then(response => {
      props.handleSubmit(response);
      localStorage.setItem("authToken", response?.data?.authToken);
    }).catch(err => {
      setError(err?.response?.data?.errorMessage || err?.response?.data?.message);
    });
  }, [props]);
  const onSubmit = data => {
    if (!data?.formData?.emailAddress && !data?.formData?.password) {
      setError(_constants.formConstants.validations.DEFAULT_BLANK);
    } else if (!data?.formData?.emailAddress) {
      setError(_constants.formConstants.validations.BLANK_EMAIL);
    } else if (!(0, _utils.validateEmail)(data?.formData?.emailAddress)) {
      setError(_constants.formConstants.validations.INVALID_EMAIL);
    } else if (!data?.formData?.password) {
      setError(_constants.formConstants.validations.BLANK_PASSWORD);
    } else {
      setError("");
      handleLogin(props.url, {
        emailAddress: data?.formData?.emailAddress,
        password: data?.formData?.password
      });
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        color: colorError
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: error
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NicheFormEngine.default, {
      schema: schema,
      uiSchema: (0, _uiSchema.uiSchema)(props.linkText, props.linkUrl),
      clearError: () => setError(""),
      handleSubmit: onSubmit
    }), props.googleAuthUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)(_NicheGoogleLogin.default, {
      googleAuthUrl: props.googleAuthUrl,
      text: "Sign in with Google"
    })]
  });
};
var _default = exports.default = NicheJwtLogin;